// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"668a847d","239":"7ccce5ac","455":"cdd64f7d"}[chunkId] + ".chunk.js";
};